import auth from '@react-native-firebase/auth';

export const retrieveAuthToken = async () => {
  return auth().currentUser?.getIdToken();
};
